import React, {
  useEffect,
  useState,
  useReducer,
  useCallback,
  useRef,
} from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "../MasterStyleDashborads/MasterStyleDashboards.scss";
import { showError, showSuccess } from "../../../../Helper";
import {
  GetLookupItemsByLookupTypeName,
  MicrosoftToken,
  lookupItemsGetId,
} from "../../../../Services";
import { SpinnerDashboards } from "../SpinnerDashboards/SpinnerDashboards";
import { DateRangePickerComponent } from "../../../../Components/Controls/DateRangePickerComponent/DateRangePickerComponent";
import moment from "moment";
import {
  AutocompleteComponent,
  Inputs,
  SelectComponet,
  ViewTypes,
} from "../../../../Components";
import {
  ActionsButtonsEnum,
  MediaEnum,
  PowerBiEnum,
  Status,
} from "../../../../Enums";
import { useTranslation } from "react-i18next";
import { OrganizationUserSearch } from "../../../../Services/userServices";
import { useSelector, useDispatch } from "react-redux";
import { GlobalOrderFilterActions } from "../../../../store/GlobalOrderFilter/GlobalOrderFilterActions";
import {
  Button,
  ButtonBase,
  ButtonGroup,
  CircularProgress,
  MenuList,
  Switch,
} from "@material-ui/core";
// import { CellsSpinner } from "../../../../SharedComponents/CellSpinnerComponent/CellsSpinner";
import { CellSpinnerBi } from "../CellSpinnerBi/CellSpinnerBi";
import { PowerBiEnumdev } from "../BIConfigDataBase/PowerBiEnumdev";
import { config } from "../../../../config";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";
import "../AdminMarketing/Navbar.scss";

const parentTranslationPath = "LeadsView";
const translationPath = "";

export const AdminBusinessDevelopment = () => {
  const { t } = useTranslation(parentTranslationPath);
  const dispatch = useDispatch();
  const [report, setReport] = useState();
  const [render, setRender] = useState(false);
  const [ShowReport, setShowReport] = useState(false);
  const [ShowReport2, setShowReport2] = useState(false);
  const [DateAppaer, setDateAppaer] = useState(false);
  const [datefilters, setdatefilter] = useState(true);
  const [activeButton, setActiveButton] = useState("One");
  const [MenuButton, setMenuButton] = useState("One");
  const [activeGroupButton, setactiveGroupButton] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState({
    referred: false,
    mediaDetails: false,
  });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const horiSelectorRef = useRef(null);
  const navbarRef = useRef(null);

  useEffect(() => {
    const updateSelector = () => {
      if (navbarRef.current && horiSelectorRef.current) {
        const tabs = navbarRef.current.querySelectorAll("li");
        if (tabs.length > 0) {
          const activeItem = tabs[activeIndex];
          const activeWidth = activeItem.offsetWidth;
          const itemPosLeft = activeItem.offsetLeft;
          horiSelectorRef.current.style.left = `${itemPosLeft}px`;
          horiSelectorRef.current.style.width = `${activeWidth}px`;
        }
      }
    };

    updateSelector();
  }, [activeIndex]);

  const handleItemClick = (index) => {
    setActiveIndex(index);
  };

  const GeneralPage = () => {
    handleMenuButtonClick("One");
    setAnchorEl(null);
     applyBookmark("24e2075282f704e7f454");
  };
  const TransactionPage = () => {
    handleMenuButtonClick("Two");
     applyBookmark("fb72ffead959ae788254");

    setAnchorEl(null);
  };
  const ZeroMatchingPage = () => {
    handleMenuButtonClick("Three");
       applyBookmark("b44956d799e7e1e8da8b");

    setAnchorEl(null);
  };


    const loadBookmarks = async () => {
    const report = window.report;
    let pages = await report.getPages();
    if (report) {
      try {
        const bookmarksManager = report.bookmarksManager;
        const fetchedBookmarks = await bookmarksManager.getBookmarks();
        console.log(pages);
        console.log(fetchedBookmarks);
        
      } catch (error) {
        console.error("Error loading bookmarks:", error);
      }
    }
  };

  const reducer = (state, action) => {
    if (action.id !== "edit") return { ...state, [action.id]: action.value };
    if (action.id === "edit") {
      return {
        ...action.value,
      };
    }
    return undefined;
  };

  const Microsoft = async (isExpired) => {
    const res = await MicrosoftToken(isExpired);
    if (!(res && res.status && res.status !== 200)) {
      setReport(res);
      setRender(true);
      setShowReport(true);
    } else {
      setReport("");
      showError("Contact Your Bi Admin For Help");
    }
  };

  useEffect(() => {
    Microsoft(false);
  }, []);

  const onClearedAllFiltersClick = useCallback(() => {
    applyBookmark("f28dc8de93b55e54f5ba");
  }, []);


  const applyBookmark = async (bookmarkName) => {
    const report = window.report;
    if (report) {
      try {
        const bookmarksManager = report.bookmarksManager;
        bookmarksManager.apply(bookmarkName);
      } catch (error) {
        console.error("Error applying bookmark:", error);
      }
    }
  };

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };
  const handleMenuButtonClick = (buttonName) => {
    setMenuButton(buttonName);
  };

  const [filterButton, setfilterButton] = useState(false);
  const [clearfilterButton, setclearfilterButton] = useState(false);

  const ChartView = () => {
    applyBookmark("Bookmarkf623b3e01f3ba3e56a23");
    handleButtonClick("One");
    setShowReport2(false);
  };
  const TableView = () => {
    applyBookmark("Bookmark7901e45cf8f0a3712730");
    handleButtonClick("Two");
    setShowReport2(false);
  };

  const FilterHide = () => {
    applyBookmark("Bookmarke8bdfc92671bb77c202b");
    setfilterButton(false);
    setclearfilterButton(false);
  };
  const FilterView = () => {
    applyBookmark("Bookmark4a47b9d51da010b8d401");
    setfilterButton(true);
    setclearfilterButton(true);
  };
  const handleRefreshClick = useCallback(() => {
    window.report
      .refresh()
      .then(() => {
        setShowReport2(false);
      })
      .catch((error) => {});
  }, []);

  const [activeThemeButton, setActiveThemeButton] = useState("blue");
  const handleButtonClick2 = (buttonName) => {
    setActiveThemeButton(buttonName);
  };



  const [checkedstate, setcheckedState] = useState({
    checkedA: false,
  });

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const Pagenavi = async (pagestate) => {
    const report = window.report;
    let pages = await report.getPages();

    if (report) {
      try {
        report.setPage(pagestate);
      } catch (error) {
        console.error("Error applying:", error);
      }
    }
  };
  const [selectedValuesInFilters, setSelectedValuesInFilters] = useState({
    Ids: null,
    mobile: null,
    agreementStatus: null,
    vendorCategory: null,
    city: null,
    country: null,
  });

  const [allItems, setAllItems] = useState({
    agreementStatus: [],
    vendorCategory: [],
    country: [],
    city: [],
    vendorClass: [],
  });

  const getLookupItemsByName = async (lookUpName, key) => {
    setIsLoading((item) => ({ ...item, [key]: true }));
    const result = await GetLookupItemsByLookupTypeName({
      lookUpName,
      pageSize: 1000,
      pageIndex: 1,
    });
    if (!(result && result.status && result.status !== 200)) {
      setAllItems((item) => ({
        ...item,
        [key]: (result && result.result) || [],
      }));
    } else setAllItems((item) => ({ ...item, [key]: [] }));
    setIsLoading((loading) => ({ ...loading, [key]: false }));
  };

  useEffect(() => {
    if (allItems && allItems.vendorClass && allItems.vendorClass.length === 0)
      getLookupItemsByName("VendorClass", "vendorClass");
  }, [allItems]);

  return (
    <div className="dashboardMain-PowerBIEmbed">
      {/* <div className="w-50 px-2">
                <AutocompleteComponent
                  key={`vendorCategory`}
                  selectedValues={selectedValuesInFilters?.vendorCategory}
                  idRef={`vendorCategoryRef`}
                  inputPlaceholder="select-vendor-category"
                  multiple={false}
                  data={allItems && allItems.vendorCategory}
                  wrapperClasses="w-50-unset mb-2"
                  displayLabel={(option) => (option && option.lookupItemName) || ""}
                  onChange={(e, newValue) => {
                    setSelectedValuesInFilters((item) => ({
                      ...item,
                      vendorCategory: newValue,
                    }));
                  }}
                  isLoading={isLoading.vendorCategory}
                  withLoader
                  withoutSearchButton
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                  onOpen={() => {
                    if (allItems?.vendorCategory?.length === 0)
                      getLookupItemsByName("VendorCategory", "vendorCategory");
                  }}
                />
              </div> */}
      <CellSpinnerBi
        isActive={!ShowReport}
        blue={activeThemeButton === "blue"}
      />
      <div>
        <div id="navbar-animmenu" ref={navbarRef}>
          <ul className="show-dropdown main-navbar">
            <div className="hori-selector" ref={horiSelectorRef}>
              <div className="left"></div>
              <div className="right"></div>
            </div>
            <li
              className={activeIndex === 0 ? "active" : ""}
              onClick={() => {
                handleItemClick(0);
                GeneralPage();
              }}
            >
              <a>
                <i className={`mdi mdi-account-details-outline mdi-24px `}></i>
                {t(`${translationPath}vendor-snapshot`)}
              </a>
            </li>
            <li
              className={activeIndex === 1 ? "active" : ""}
              onClick={() => {
                handleItemClick(1);
                TransactionPage();
              }}
            >
              <a>
                <i className={`mdi mdi-book-account-outline mdi-24px `}></i>
                {t(`${translationPath}offer-snapshot`)}
              </a>
            </li>
            <li
              className={activeIndex === 2 ? "active" : ""}
              onClick={() => {
                handleItemClick(2);
                ZeroMatchingPage();
              }}
            >
              <a>
                <i className={`mdi mdi-help-circle mdi-24px `}></i>
                {t(`${translationPath}client-snapshot`)}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <br />
      {render && (
        <div className="mainCardDashboards">
          <div
            className={`dashboardMain  ${
              activeThemeButton === "gold"
                ? "cardDashboardgold"
                : "cardDashboard"
            }`}
          >
            <div>
              <br />
              {DateAppaer && (
                <div>
                  <div className="MainFiltersBi">
                    <CellSpinnerBi
                      isActive={!ShowReport2}
                      blue={activeThemeButton === "blue"}
                    />
{/* 
                    {!filterButton ? (
                      <div className="DashboardFilter">
                        <ButtonBase
                          variant="contained"
                          className="btns theme-solid bg-primary-dark Dashboardbtn"
                          style={{ color: "white" }}
                          onClick={FilterView}
                          disabled={
                            activeButton == "Two" || activeGroupButton == false
                          }
                        >
                          <span className="mdi mdi-filter-menu m-1" />
                        </ButtonBase>
                      </div>
                    ) : (
                      <div className="DashboardFilter">
                        <ButtonBase
                          variant="contained"
                          className="btns theme-solid bg-danger Dashboardbtn"
                          style={{ color: "white" }}
                          onClick={FilterHide}
                        >
                          <span className="mdi mdi-filter-minus-outline m-1" />
                        </ButtonBase>
                      </div>
                    )} */}

                    <div className="DashboardFilter">
                      <ButtonBase
                        onClick={onClearedAllFiltersClick}
                        id="onClearedAllFiltersref"
                        className="btns theme-solid bg-primary-dark clear-all-btn Dashboardbtn"
                        disabled={
                          activeGroupButton == false ||
                          clearfilterButton == true
                        }
                      >
                        <span className="mdi mdi-filter-remove m-1" />
                      </ButtonBase>
                    </div>
                    <div className="DashboardFilter">
                      <ButtonBase
                        onClick={handleRefreshClick}
                        id="onClearedAllFiltersref"
                        className="btns theme-solid  clear-all-btn Dashboardbtn clearBtn"
                      >
                        <span className="mdi mdi-refresh m-1" />
                      </ButtonBase>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <br />

            <PowerBIEmbed
              embedConfig={{
                type: "report",
                id: PowerBiEnum.BusinessDevelopment.reportid,
                embedUrl: PowerBiEnum.BusinessDevelopment.url,
                accessToken: report,
                // filters: [

                // ],
                settings: {
                  customLayout: {
                    displayOption: models.DisplayOption.FitToWidth,
                  },
                  filterPaneEnabled: false,
                  navContentPaneEnabled: false,
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },
                  },
                  background: models.BackgroundType.Transparent,
                },
              }}
              eventHandlers={
                new Map([
                  [
                    "loaded",
                    (event) => {
                      setDateAppaer(true);

                      setShowReport2(false);
                    },
                  ],
                  [
                    "dataSelected",

                    (event) => {
                      setShowReport2(false);
                    },
                  ],

                  [
                    "rendered",
                    (event) => {
                      setShowReport2(true);
                      setRender(true);
                      loadBookmarks();
                      // const start = performance.now();
                      // setTimeout(() => {
                      //   const end = performance.now();

                      //   const duration = end - start;
                      // }, 0);
                    },
                  ],

                  [
                    "pageChanged",
                    (event) => {
                      const newPageName = event.detail.newPage.displayName;

                      switch (newPageName) {
                        case "Zero Matching":
                          setTimeout(() => {
                            scrollToTop();
                          }, 5);

                          break;
                        case "Transaction ":
                          setTimeout(() => {
                            scrollToTop();
                          }, 5);
                          break;
                        default:
                          setTimeout(() => {
                            scrollToTop();
                          }, 5);
                          break;
                      }
                    },
                  ],

                  [
                    "error",
                    (event) => {
                      const error = event.detail;
                      if (
                        error.detailedMessage === "Get report failed" ||
                        error.detailedMessage ===
                          "Access token has expired, resubmit with a new access token" ||
                        error.detailedMessage ===
                          "Fail to initialize - Could not resolve cluster"
                      ) {
                        Microsoft(true);
                        setRender(false);
                      } else showError(error.detailedMessage);
                    },
                  ],
                ])
              }
              cssClassName={
                ShowReport
                  ? "report-style-class-Show"
                  : "report-style-class-hide"
              }
              getEmbeddedComponent={(embeddedReport) => {
                window.report = embeddedReport;
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
